import React from 'react';

import {BaseProps} from "../../../../infrastructure/models/props/base-props";
import classNames from "classnames";
import styles from "../styles/carousel.module.scss"
import {ArrowChevronRequestParams} from "../../../icons/arrow-chevron.request-params";
import {useThemeColor} from "../../../../infrastructure/hooks/useThemeColor";
import {COLORS} from "../../../app/consts/colors";
import {SVGImage} from "../../image/svg-image";

export class CarouselArrowLargeProps extends BaseProps {
  isPrev: Boolean = false;
  label: String;
  onClick: Function;
  isSmallView: Boolean;
}

export const CarouselArrowLarge = (props: CarouselArrowLargeProps) => {
  const containerProps = {
    className: classNames(styles.arrow_large_container, {
      [styles.arrow_large_container_prev]: props.isPrev,
      [styles.arrow_large_container_next]: !props.isPrev
    }, props.className),
    onClick: () => props.onClick()
  };

  const arrowProps = {
    className: classNames(styles.arrow_large, {
      [styles.arrow_large_prev]: props.isPrev,
      [styles.arrow_large_next]: !props.isPrev
    }),
    src: new ArrowChevronRequestParams(24, 24, '_Right'),
    fillcolor: useThemeColor(COLORS.textSecondary)
  };

  return (
    <div {...containerProps}>
      <SVGImage {...arrowProps}/>
    </div>
  )
};
